import { EMS_ENVIRONMENT } from 'tools/utils/libs/helper';

import ApiMapV2 from './ApiMapV2';

// 授信环节接口的统一路径（所有API的第一个词） 开发环境不过网关 统一都是空字符串；测试和线上环境会过网关三个环节分别是不同的词
// export const isDev = process.env.NODE_ENV === 'development';
// 统一处理环境变量，以便和setupProxy里的代理地址保持统一,若不想保持一致，可以使用上面的方式进行判断
const isDev = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_IS_DEBUG === 'true' : false;

const CREDIT_API = isDev ? '' : '/credit';
// 用信环节接口的统一路径
const LOAN_API = isDev ? '' : '/withdraw';
// 还款环节接口的统一路径
const REPAY_API = isDev ? '' : '/repay';
// 授信成功页面也是用信首页也是还款首页
const CONVENIENT_API = isDev ? '' : '/convenient';
// 换绑卡功能
const BINDCARD_API = isDev ? '' : '/bindingcard';
// 公众号appid
export const NOT_PRD_ENV = !(!isDev && window.location.protocol === 'https:' && window.location.host === 'haojie.58.com');
export const wechartAppid = NOT_PRD_ENV ? 'wx5f0c40fd03e08e88' : 'wxd9f3353986e57b95';

export const ApiMap = {
    /**
     * 用信接口地址
     */
    // 获取民族列表
    getNationList: `${LOAN_API}/supply/record/basic/nation`,
    // 用信-审核成功页面初始化
    loanAuditSuccess: `${LOAN_API}/order/amount`,
    // 用信获取脱敏姓名和身份证号信息
    getPersonalInfoWithDraw: `${LOAN_API}/supply/record/face/baseInfo`,
    /**
     * 授信接口地址
     */
    //
    getLoginInitStas: `${CREDIT_API}/login/v1/init`,

    // 获取ems申请页静态资源
    getApplyContent: `${EMS_ENVIRONMENT}/api/ems/get/data`,

    // 获取Iconlist测试
    getIconListTest: '//emsapi.58v5.cn/api/ems/get/data',

    // 获取Iconlist线上
    getIconListOnline: '//emsapi.58.com/api/ems/get/data',

    // 获取wos上传token
    getWosToken: `${CREDIT_API}/face/wos/token`,

    /**
     * 还款接口
     */
    // 获取还款结果
    getRepayResult: `${REPAY_API}/v1/order/detail`,
    // 获取借款记录
    getBorrowRecord: `${REPAY_API}/v1/loan/list`,
    // 获取借款详情
    getBorrowDetail: `${REPAY_API}/v1/loan/detail`,
    // 获取按期还款还款详情
    getTermDetail: `${REPAY_API}/v1/term/detail`,
    // 查询提前结清还款详情
    getAllDetail: `${REPAY_API}/v1/advance/detail`,
    // 查询提前结清还款详情
    checkCanPay: `${REPAY_API}/v2/check`,
    // 还款-获取合同列表
    getContractList: `${REPAY_API}/v1/contract/list/init`,
    // 还款-查询合同
    getContractListContent: `${REPAY_API}/v1/contract/info/get`,
    // 获取合同详情
    getContractDetail: `${LOAN_API}/order/contract/detail`,
    // 发起还款
    goPay: `${REPAY_API}/v4/apply`,
    // 发起还款需验证码认证，获取验证码
    getPaySmsCode: `${REPAY_API}/v1/repay/sendVerifyCode`,
    //信用飞验证还款验证码
    checkPaySmscode: `${REPAY_API}/v1/repay/confirmVerifyCode`,
    // 发起PC端还款
    goPcPay: `${REPAY_API}/v1/pc/apply`,
    // 换绑卡 获取卡bin信息
    getBankInfo: `${BINDCARD_API}/card/v2/cardinfo`,
    // 换绑卡 预绑卡
    preBindBankCard: `${BINDCARD_API}/card/v2/add/prebind`,
    // 换绑卡 确认绑卡
    bindBankCard: `${BINDCARD_API}/card/v2/bind/confirm`,
    // 查询借款结清记录列表
    getBorrowCertificationRecord: `${REPAY_API}/v1/certification/list`,
    // 生成结清证明
    createCertification: `${REPAY_API}/v1/create/certification`,
    // 获取结清合同pdf
    getCertificationPDF: `${REPAY_API}/v1/certification/down`,

    /**
     * 埋点数据上报
     */
    // 风控埋点数据上报
    riskPoint: '/riskreport/risk/report/device',
    // 业务埋点上报
    businessPoint: `${CREDIT_API}/report/risk`,

    // 风控借款流程时间段数据上报
    riskPointTimestamp: '/riskreport/risk/report/behavior',

    // 短链接埋点url
    spreadShortPonit: `${CONVENIENT_API}/buried/point`,
    // 新版短链接滚动数据
    newSpreadScrollData: `${CONVENIENT_API}/v1/rolling/data`,
    // 神奇矿轮播条数据
    magicPageInitdata: `${CONVENIENT_API}/magic/ore/v1/carousel`,
    // 新手提额按钮状态
    newUserInitdata: `${CONVENIENT_API}/active/v1/newbie/up`,
    // 新手提额点击按钮触发
    newUserclickdata: `${CONVENIENT_API}/active/v1/base/point`,
    // 神奇矿2期初始化展示数据
    magicPageInitShowdata: `${CONVENIENT_API}/magic/ore/v1/init`,
    // 二手车轮播条配置
    activityCarCarousel: `${CONVENIENT_API}/used/car/v1/carousel`,


};

/**
 * 需要加解密的url列表
 */
export const needEntryptUrlList = [
    ApiMapV2.creditUploadOcr, // 授信-验二OCR 身份证ocr
    ApiMapV2.verifyBaseInfoSubmit, // 增验-基本信息提交
    ApiMapV2.emergencySubmit, // 增验-紧急联系人提交
    ApiMapV2.preBindCard, // 绑卡-预绑卡提交
    ApiMapV2.bindCard, // 绑卡-绑卡提交
    ApiMapV2.preRebindCard, // 绑卡-重新预绑卡
    ApiMapV2.confirmRebindCard, // 绑卡-重新提交绑卡
    ApiMapV2.msgSendV2, // 发送验证码
    ApiMapV2.postUserIdNumberV1,    // 提交用户姓名身份证信息
    ApiMapV2.getToken,    // 提交用户姓名身份证信息
    ApiMapV2.ocrUploadV3,   // 用信身份证扫描结果ocr上传
    ApiMapV2.ocrSubmitV3,   // 用信ocr信息提交
    ApiMapV2.ocrVerifySubmit,   // 新流程用信增验ocr信息提交
    ApiMapV2.postIdCardInfo,    // 授信验二提交-实验组
    // get请求，目前加密没有用
    ApiMapV2.newFaceAccreditInit,   // 授信人脸初始化
    ApiMapV2.loanRouteTrail,        // 用信-路由试算接口
    ApiMapV2.verifyBaseInfo,        // 增验-基本信息回显
    ApiMapV2.emergencyInfo,         // 增验-紧急联系人回显
    ApiMapV2.bankCardAddInit,       // 绑卡-绑卡初始化
    ApiMapV2.getMobileAndBandInfo,  // 获取当前订单绑定手机号和银行卡信息
    ApiMapV2.getUserIdNumber,       // 授信获取用户姓名身份证信息

];


export { ApiMapV2 };
